module.exports = __webpack_public_path__ + "37d03afd9e804052db57f844548f9cac.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/personen.png
// module id = 53
// module chunks = 1